import React from 'react';
import { Segmented } from 'antd';

export const SCOPE_COLLECTION = 'collection';
export const SCOPE_COMBINED = 'combined';

/**
 * THE SCOPE SWITCH (KPR-1022; plan §4 "reachable from a List"): on a List that
 * shows one card a person also has in other collections — and on the combined
 * list it opens — "This collection · All my Recipes". Searching your own
 * recipes is one click from searching every one of them, and back.
 *
 * The switch only says where; the page decides what comes along (the search
 * and the filter, Zach 2026-10-20) and where it goes (a saved list on the
 * match, else an unsaved one). `onChange(scope)`.
 */
export default function CombinedScopeSwitch({ value = SCOPE_COLLECTION, plural = 'items', onChange, disabled = false, className = '' }) {
	return (
		<Segmented
			className={`combined-scope-switch ${className}`.trim()}
			value={value}
			onChange={onChange}
			disabled={disabled}
			aria-label="Which collections"
			data-testid="combined-scope-switch"
			options={[
				{ value: SCOPE_COLLECTION, label: 'This collection' },
				{ value: SCOPE_COMBINED, label: `All my ${plural}` },
			]}
		/>
	);
}
